import { connectedStore } from '../../store';
import copyElementAction from '../actions/copy-element';
import { USED_ACTION_CREATOR } from '../constants/symbols';

const copyElement = (elementId, options) => {
  const store = connectedStore.get();
  store.dispatch(copyElementAction(elementId, options));
};

copyElement[USED_ACTION_CREATOR] = copyElementAction;

export default copyElement;
